export type Folder = {
  parentFolders: Omit<Folder, 'parentFolders'>[];
  id: string;
  name: string;
};

export const rootFolderId = 'root';
